import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 text-center">
      <h3 className="text-2xl font-bold text-white mb-2">Smarty</h3>
      <p>Empowering learners everywhere 🌍</p>

      <p className="text-sm mt-4 text-gray-500">
        © {new Date().getFullYear()} Smarty Inc. All rights reserved.
      </p>

      <Link to="/privacy-policy">Privacy Policy</Link><br />
      <Link to="/terms-of-use">Terms Of Use</Link>
    </footer>
  );
}
